import { ComponentConfig } from "@measured/puck";
import { Image as ImageComponent } from "./Image";
import { ImageProps } from "./types";

export const Image: ComponentConfig<ImageProps> = {
    label: "Image",
    fields: {
        src: {
            type: "text",
            label: "Image URL",
        },
        alt: {
            type: "text",
            label: "Alt Text",
        },
        caption: {
            type: "text",
            label: "Caption (optional)",
        },
        width: {
            type: "text",
            label: "Width",
        },
        height: {
            type: "text",
            label: "Height",
        },
        objectFit: {
            type: "radio",
            label: "Object Fit",
            options: [
                { label: "Contain", value: "contain" },
                { label: "Cover", value: "cover" },
                { label: "Fill", value: "fill" },
                { label: "None", value: "none" },
                { label: "Scale Down", value: "scale-down" },
            ],
        },
        alignment: {
            type: "radio",
            label: "Alignment",
            options: [
                { label: "Left", value: "left" },
                { label: "Center", value: "center" },
                { label: "Right", value: "right" },
            ],
        },
        borderRadius: {
            type: "text",
            label: "Border Radius",
        },
        shadow: {
            type: "radio",
            label: "Shadow",
            options: [
                { label: "Yes", value: true },
                { label: "No", value: false },
            ],
        },
    },
    defaultProps: {
        src: "https://placehold.co/300x300",
        alt: "",
        width: "300px",
        height: "300px",
        objectFit: "cover",
        alignment: "center",
        borderRadius: "8px",
        shadow: false,
    },
    render: (props) => <ImageComponent {...props} />,
};
